import { render, staticRenderFns } from "./VerRegistros.vue?vue&type=template&id=023ccd6a&scoped=true"
import script from "./VerRegistros.vue?vue&type=script&lang=ts"
export * from "./VerRegistros.vue?vue&type=script&lang=ts"
import style0 from "./VerRegistros.vue?vue&type=style&index=0&id=023ccd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ccd6a",
  null
  
)

export default component.exports